import http from "@/http-common.js";

class ChessService {
  basePathApiService = "/chess/filter";
  getAll(filter) {
    return http.get(this.basePathApiService, filter);
  } 
}
export default new ChessService();
